import React, { useState, useEffect } from 'react';
import { FaRedoAlt, FaFastForward } from 'react-icons/fa';
import { BiUser, BiLock, BiHide, BiShow } from 'react-icons/bi';
import { TextField, InputAdornment } from '@material-ui/core';
import Swal from 'sweetalert2';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { useHistory } from "react-router-dom";
import { LOGIN_DOMAIN } from "../Services/Configuration";
import HousingService from "../Services/HousingService";
import { fontFamily } from '@mui/system';
import * as OFMSUI from "react-bootstrap";
import { store } from '../App';


const Login = () => {
  const [captcha, setCaptcha] = useState('');
  const [buttonHovered, setButtonHovered] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const history = useHistory();

  useEffect(() => {
    generateCaptcha();
    showTime();
  }, []);

  const generateCaptcha = () => {
    const captchaChars = 'ABCDEFGHJKLMNOPQRSTUVWXYZ';
    let captchaVal = '';
    const array = new Uint32Array(5);
    crypto.getRandomValues(array);

    for (let i = 0; i < array.length; i++) {
      const randomIndex = array[i] % captchaChars.length;
      captchaVal += captchaChars.charAt(randomIndex);
    }

    setCaptcha(captchaVal);
  };

  const handleReloadCaptcha = () => {
    generateCaptcha();
  };

  const showNotification = (type, message) => {
    if (type === 'success') {
      Swal.fire('Success', message, 'success');
    } else if (type === 'error') {
      Swal.fire('Error', message, 'error');
    } else if (type === 'warning') {
      Swal.fire('Warning', message, 'warning');
    } else if (type === 'info') {
      Swal.fire('info', message, 'info');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const initialValues = {
    username: '',
    password: '',
    captchaInput: '',
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required('Username is required'),
    password: Yup.string().required('Password is required'),
    captchaInput: Yup.string().required('Captcha is required').matches(new RegExp(`^${captcha}$`), 'Invalid Captcha'),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      // try {
      //   store.dispatch({ type: "SHOW_SPINNER" })
      //   const response = await HousingService.loginDetails({ username: values.username, password: values.password });
      //   if (response?.data?.status === "S01") {
      //     if (response?.data?.flag_password_change === "false") {
      //       console.log("Setting local storage for user and token");
      //       localStorage.setItem("user", JSON.stringify(response.data));
      //       localStorage.setItem("token", JSON.stringify(response.data.accessToken));
      //       localStorage.setItem("username", values.username);
      //       store.dispatch({ type: "HIDE_SPINNER" })
      //     }
      //     else if (response?.data?.flag_password_change === "true") {
      //       store.dispatch({ type: "HIDE_SPINNER" })
      //       HousingService.keycloaktokengeneration().then((res) => {
      //         localStorage.setItem("keycloaktoken", res.data[0].Access_token.access_token);
      //       })
      //       localStorage.setItem("user", JSON.stringify(response.data));
      //       localStorage.setItem("token", JSON.stringify(response.data.accessToken));
      //       localStorage.setItem("username", values.username);
      //       history.push("/Dashboardheader");
      //     }
      //   }
      //   else if (response?.data?.status === "S02") {
      //     console.error('Error in form submission:', error);
      //     showNotification('error', 'Invalid Username or password.');
      //     store.dispatch({ type: "HIDE_SPINNER" })
      //   }
      //   else {
      //     showNotification('error', 'Failed to login. Please try again.');
      //     store.dispatch({ type: "HIDE_SPINNER" })
      //   }
      // }
      try {
        store.dispatch({ type: "SHOW_SPINNER" })
        const response = await HousingService.loginDetails({ username: values.username, password: values.password });
        if (response?.data?.status === "S01") {
            store.dispatch({ type: "HIDE_SPINNER" })
            HousingService.keycloaktokengeneration().then((res) => {
              localStorage.setItem("keycloaktoken", res.data[0].Access_token.access_token);
            })
            localStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("token", JSON.stringify(response.data.accessToken));
            localStorage.setItem("username", values.username);
            history.push("/Dashboardheader");
        }
        else if (response?.data?.status === "S02") {
          console.error('Error in form submission:', error);
          showNotification('error', 'Invalid Username or password.');
          store.dispatch({ type: "HIDE_SPINNER" })
        }
        else {
          showNotification('error', 'Failed to login. Please try again.');
          store.dispatch({ type: "HIDE_SPINNER" })
        }
      }
      catch (error) {
        console.error('Error in form submission:', error);
        showNotification('error', 'Invalid Username or password.');
        store.dispatch({ type: "HIDE_SPINNER" })
      }

    },
  });

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '4rem 2rem',
      // backgroundColor: '#FBF9FB',
      backgroundColor: '#FAF9F6',
    },
    header: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '2rem',
    },
    img: {
      marginTop: '10px',
      height: '50px',
    },
    innerContainer: {
      margin: '0 auto',
      width: '100%',
      maxWidth: '30rem',
    },
    title: {
      marginTop: '0.8rem',
      fontSize: '1.6rem',
      fontWeight: '500',
      textAlign: 'center',
      color: 'black',
      lineHeight: '2.5rem',
      fontFamily: "Poppins"
    },
    // ofmstitle: {
    //   marginTop: '4rem',
    //   fontSize: '2rem',
    //   fontWeight: '600',
    //   textAlign: 'center',
    //   lineHeight: '2.5rem',
    //   fontFamily: "Georgia",
    //   color: '#F28C28',
    // },
    ofmstitle: {
      marginTop: '4rem',
      fontSize: '2rem',
      fontWeight: '700', // Bold
      textAlign: 'center',
      lineHeight: '2.5rem',
      fontFamily: "'Arial', 'Helvetica', sans-serif", // Matches the reference
      color: '#F28C28', // Same saffron-orange shade
      textTransform: 'capitalize', // Like the sample text
      letterSpacing: '0.5px',
    },



    formContainer: {
      marginTop: '1.0rem',
      padding: '2.5rem',
      backgroundColor: 'white',
      boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)',
      borderRadius: '0.5rem',
    },
    labelContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1.5rem',
    },
    label: {
      marginLeft: '0.5rem',
      fontSize: '1rem',
      fontWeight: '500',
      color: 'black',
      lineHeight: '1.5rem',
    },
    inputContainer: {
      marginTop: '0.5rem',
      borderRadius: '0.375rem',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    },
    input: {
      appearance: 'none',
      display: 'block',
      width: '100%',
      padding: '0.75rem 1rem',
      border: '1px solid #d2d6dc',
      borderRadius: '0.375rem',
      placeholder: '#a0aec0',
      outline: 'none',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
      transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    buttonContainer: {
      marginTop: '2rem',
    },
    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      padding: '0.75rem 1.5rem',
      fontSize: '1rem',
      fontWeight: '500',
      color: 'white',
      backgroundColor: buttonHovered ? '#198754' : '#157147',
      border: '1px solid transparent',
      borderRadius: '0.375rem',
      transition: 'background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden',
    },
    buttonText: {
      zIndex: 1,
    },
    hoverIcon: {
      position: 'absolute',
      top: '50%',
      right: '10px',
      transform: 'translateY(-50%)',
      transition: 'transform 0.1s ease-out',
      zIndex: 0,
    },
    captchaContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '2rem',
    },
    captchaBox: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #ccc',
      padding: '10px',
      width: 'auto',
      height: '45px',
      color: 'black',
    },
    captchaText: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginRight: '15px',
      backgroundImage: 'linear-gradient(to right, #603913, #A0522D)',
      color: 'transparent', // keep only this one if you want the gradient
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      userSelect: 'none',
      cursor: 'default'
    },
    captchaInput: {
      width: '200px',
      marginLeft: '15px',
    },
    captchaTextField: {
      width: '100%',
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    toggleButton: {
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      color: '#603913',
      fontSize: '1.75rem',
      display: 'flex',
      alignItems: 'center',
      marginLeft: '0.5rem',
    },
    icon: {
      fontSize: '1.75rem',
      color: '#F28C28'
    },
    errorMessage: {
      color: 'red',
    },
    clock: {
      position: 'absolute',
      bottom: '4rem',
      right: '1rem',
      color: '#A0522D',
      fontSize: '26px',
      fontFamily: 'Orbitron',
      letterSpacing: '1px',
      zIndex: 1000,
      fontWeight: '400',
    },
  };
  function showTime() {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednessday', 'Thursday', 'Friday', 'Saturday '];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    var date = new Date();
    var dayOfWeek = days[date.getDay()]; // Get day name
    var day = date.getDate(); // Get day of the month
    var month = months[date.getMonth()]; // Get month name
    var year = date.getFullYear(); // Get full year
    var h = date.getHours(); // 0 - 23
    var m = date.getMinutes(); // 0 - 59
    var s = date.getSeconds(); // 0 - 59
    var session = "AM";

    if (h === 0) {
      h = 12;
    }

    if (h > 12) {
      h = h - 12;
      session = "PM";
    }

    h = (h < 10) ? "0" + h : h;
    m = (m < 10) ? "0" + m : m;
    s = (s < 10) ? "0" + s : s;

    var dateTimeString = ` ${day} ${month} ${year},${dayOfWeek} ${h}:${m} ${session}`;

    document.getElementById("MyClockDisplay").innerText = dateTimeString;
    document.getElementById("MyClockDisplay").textContent = dateTimeString;

    setTimeout(showTime, 1000);
  }
  return (
    <>
      <OFMSUI.Row className="fixed-top logo-part d-flex  align-items-center  totalnav">
        <OFMSUI.Col xs={4} sm={4} md={1} lg={1} xl={1} xxl={1} className="mobileicon">
          <img src="img/ap-logo.png" style={{ marginleft: "19px" }} className="img-fluid" width={80} height={80} />
        </OFMSUI.Col>
        <OFMSUI.Col md={3} lg={3} xl={3} xxl={3} className="nouse">
          <img src="img/cm.png" className="img-fluid" />
        </OFMSUI.Col>
        <OFMSUI.Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4} className="d-flex justify-content-center align-items-center p-1 departmentname">
          <div style={{ width: "62%", textAlign: "center" }}> <h1>Andhra Pradesh State Housing Corporation Limited</h1> </div>
        </OFMSUI.Col>
        <OFMSUI.Col md={3} lg={3} xl={3} xxl={3} className="nouse">
          <img src="img/minister.png" className="img-fluid" />
        </OFMSUI.Col>
        <OFMSUI.Col xs={4} sm={4} md={1} lg={1} xl={1} xxl={1} className="mobileicon">
          <img src="img/logo.png" className="img-fluid" width={80} height={80} />
        </OFMSUI.Col>
      </OFMSUI.Row>
      <div style={styles.container}>
        {/* <div style={styles.header}>
        <img src="img/APSHCL.png" alt="APSHCL" style={styles.img} />
      </div> */}

        <h2 style={styles.ofmstitle} >Online Finance Management System</h2>
        <div style={styles.innerContainer}>
          <h2 style={styles.title}>Login</h2>
          <div style={styles.formContainer}>
            <FormikProvider value={formik}>
              <form onSubmit={formik.handleSubmit}>
                <div style={styles.labelContainer}>
                  <BiUser style={styles.icon} />
                  <label htmlFor="username" style={styles.label}>
                    User name:
                  </label>
                </div>
                <div style={styles.inputContainer}>
                  <input
                    id="username"
                    name="username"
                    type="text"
                    required
                    autoFocus
                    style={styles.input}
                    value={formik.values.username}
                    // onChange={formik.handleChange}
                    onChange={(e) => formik.setFieldValue("username", e.target.value.toUpperCase())}

                    onBlur={formik.handleBlur}
                  />
                </div>
                {formik.touched.username && formik.errors.username ? (
                  <div>{formik.errors.username}</div>
                ) : null}

                <div style={{ ...styles.labelContainer, marginTop: '1.5rem' }}>
                  <BiLock style={styles.icon} />
                  <label htmlFor="password" style={styles.label}>
                    Password:
                  </label>
                  <button
                    type="button"
                    style={styles.toggleButton}
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <BiHide /> : <BiShow />}
                  </button>
                </div>
                <div style={styles.inputContainer}>
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    required
                    style={styles.input}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                {formik.touched.password && formik.errors.password ? (
                  <div>{formik.errors.password}</div>
                ) : null}

                <div style={styles.captchaContainer}>
                  <div style={styles.captchaBox}>
                    <span style={styles.captchaText}>{captcha}</span>
                    <FaRedoAlt
                      onClick={handleReloadCaptcha}
                      style={{ fontSize: '30px', cursor: 'pointer' }}
                    />
                  </div>
                  <TextField
                    style={styles.captchaInput}
                    onChange={(e) => formik.setFieldValue("captchaInput", e.target.value.toUpperCase())}
                    onBlur={formik.handleBlur}
                    required
                    type="text"
                    name="captchaInput"
                    value={formik.values.captchaInput}
                    label="Enter Captcha"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                      inputProps: {
                        style: styles.captchaTextField,
                      },
                    }}
                  />
                  {formik.touched.captchaInput && formik.errors.captchaInput ? (
                    <div style={styles.errorMessage}>{formik.errors.captchaInput}</div>
                  ) : null}
                </div>

                <div style={styles.buttonContainer}>
                  <button
                    type="submit"
                    style={styles.button}
                    onMouseEnter={() => setButtonHovered(true)}
                    onMouseLeave={() => setButtonHovered(false)}
                    disabled={formik.isSubmitting}
                  >
                    <span style={styles.buttonText}>Sign In</span>
                    <FaFastForward
                      style={{
                        ...styles.hoverIcon,
                        transform: buttonHovered
                          ? 'translateY(-50%) scale(1)'
                          : 'translateY(-50%) scale(0)',
                      }}
                    />
                  </button>
                </div>
              </form>
            </FormikProvider>
          </div>
        </div>
      </div>
      <div style={styles.clock} id="MyClockDisplay"></div>
    </>
  );
};

export default Login;